<template>
  <v-container style="padding: 0; margin: 0">
    <v-layout wrap flex>
      <v-flex
        xs12>
        <Topo :empresa="empresa"/>
        <v-card
          v-show="exportando_dados"
          :max-height="heightCard"
          :style="(exportando_dados)?'overflow: auto; background-color: #E1E1E1':'overflow: auto;'"
          class="mb-3"
        >
          <v-layout
            v-if="exportando_dados"
            :style="{'height': heightCard}"
            column
            fill-height
            justify-center
            align-center
          >
            <img
              :style="{'height': '200px'}"
              src="assets/videos/brcorte_caw.gif" >
          <!--
                    <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                  >
                  </v-progress-circular>-->
          </v-layout>
        </v-card>
        <v-container
          v-show="!exportando_dados"
          grid-list-md>
          <v-layout
            v-if="user.permissao === 0 || (user.emp_user)"
            row
            wrap>
            <template v-if="user.permissao === 0 || (user.emp_user && user.emp_user.acesso < 3)">
              <v-flex
                md6
                xs12>
                <v-select
                  v-if="usuariosSelecionados.length === 0 && filterItems && filterItems !== null && filterItems.length > 1"
                  v-model="tiposUsuarios"
                  :items="filterItems"
                  :item-text="'nome'"
                  :label="strings[idioma].filtrar_cargo"
                  :disabled="dietasNaoVinculados"
                  attach
                  chips
                  multiple
                  @change="reload"
                />
              </v-flex>
              <v-flex

                md6
                xs12>
                <v-autocomplete
                  v-if="tiposUsuarios.length === 0 && filterUsers && filterUsers !== null && filterUsers.length > 1"
                  v-model="usuariosSelecionados"
                  :items="filterUsers"
                  :item-text="'NOME'"
                  :item-value="'email'"
                  :label="strings[idioma].filtrar_colaborador"
                  :disabled="dietasNaoVinculados"
                  no-data-text=""
                  attach
                  chips
                  multiple
                  @change="reload"
                />
              </v-flex>
            </template>
            <v-flex
              v-if="false"
              md6
              xs12>
              <v-select
                v-model="tiposDieta"
                :items="filterTipoDieta"
                :item-text="'nome'"
                :label="strings[idioma].tipos"

                attach
                chips
                multiple
                @change="reload"
              />
            </v-flex>
            <v-flex
              md12
              xs12>
              <v-select
                v-model="tiposAnimais"
                :items="filterTipos"
                :item-text="'nome'"
                :label="strings[idioma].tipos_animais"
                attach
                chips
                multiple
                @change="reload"
              />
            </v-flex>
            <v-flex
              md6
              xs12>
              <v-text-field
                v-model="dataInicial"
                :label="strings[idioma].data_inicio"
                type="date"
                min="1970-01-01"
                @change="reload"
              />
            </v-flex>
            <v-flex
              md6
              xs12>
              <v-text-field
                v-model="dataFinalTest"
                :label="strings[idioma].data_final"
                type="date"
                @change="reload"
              />
            </v-flex>
            <v-flex
              sm4
              xs12>
              <v-checkbox
                :disabled="predicoes"
                v-model="dietasAtivas"
                :label="strings[idioma].dietas_ativas"/>
            </v-flex>
            <v-flex
              sm4
              xs12>
              <v-checkbox
                :disabled="predicoes"
                v-model="dietasFinalizadas"
                :label="strings[idioma].dietas_finalizadas"/>
            </v-flex>
            <v-flex
              sm4
              xs12>
              <v-checkbox
                :disabled="dietasFinalizadas || dietasAtivas"
                v-model="predicoes"
                :label="strings[idioma].predicoes"/>
            </v-flex>
            <v-flex
              sm4
              xs12>
              <v-checkbox
                v-model="dietasNaoVinculados"
                :label="strings[idioma].nao_vinculados"/>
            </v-flex>
          </v-layout>

          <v-card>
            <v-card-title>
              <h2>{{ strings[idioma].relatorios }}</h2>
              <v-spacer/>

              <v-text-field
                v-model="search"
                :label="strings[idioma].pesquisar"
                append-icon="mdi-magnify"
                single-line
                hide-details
              />
              <v-spacer/>
              <v-flex md2>
                <v-select
                  v-model="pagination.rowsPerPage"
                  :items="totalItems"
                  :label="strings[idioma].itens_por_pagina"
                  small/>
              </v-flex>
            </v-card-title>
            <v-data-table
              id="dash"
              :headers="headers"
              :items="dataWeb"
              :search="search"
              :pagination.sync="pagination"
              hide-actions
              flat
            >
              <template
                slot="items"
                slot-scope="props">
                <td :color="props.item.ativa ? 'green': 'primary'">
                  <v-checkbox
                    :input-value="props.item.selecionado"
                    :color="'primary'"
                    hide-details
                    @click.stop="selecionaItem(props.item);"
                  />
                  <a
                    href="javascript:void(0);"
                    @click="openDieta(props.item.id)">{{ props.item.id }} <span v-if="props.item.ativa">(Ativa)</span></a></td>
                <td>{{ props.item.user_NOME }}</td>
                <td>{{ props.item.user_email }}</td>
                <td>{{ props.item.time }}</td>
                <td>{{ props.item.tipo }}</td>
                <td>{{ props.item.peso_corporal_inicial }}</td>
                <td>{{ props.item.peso_corporal_final }}</td>
                <td>{{ props.item.peso_corporal_medio }}</td>
                <td>{{ props.item.ganho_medio_diario }}</td>
                <td>{{ props.item.raca }}</td>
                <td>{{ props.item.regime }}</td>
                <td>{{ props.item.sexo }}</td>
                <td>{{ props.item.estado_fisiologico }}</td>
                <td>{{ props.item.custo }}</td>
                <td>{{ props.item.proporcao_volumoso }}</td>
                <td
                  height="200px"
                  v-html="props.item.resultado"/>
                <td
                  v-for="(h, index) in Object.keys(relatorioFinanceiroEstrutura.IAE)"
                  :key="rand()+'_'+index">{{ props.item[h] }}</td>
                <td
                  v-for="(h, index) in Object.keys(relatorioFinanceiroEstrutura.ATC)"
                  :key="rand()+'_'+index">{{ props.item[h] }}</td>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="mdi-warning">
                {{ String(strings[idioma].sua_pesquisa_por_x_nao_foram_encontrado).format(search) }}
              </v-alert>
              <template v-slot:no-data>
                {{ strings[idioma].nao_foram_encontrados_resultados }}
              </template>

            </v-data-table>
            <template>
              <div
                v-if="pagination.totalItems > pagination.rowsPerPage"
                class="text-xs-center">
                <v-layout
                  align-start
                  justify-space-around
                  wrap
                  justify-center
                  center>
                  <v-flex md12>
                    <v-pagination
                      v-model="pagination.page"
                      :length="Math.ceil(pagination.totalItems / pagination.rowsPerPage)"
                      :total-visible="Math.ceil(pagination.totalItems / pagination.rowsPerPage) < pagination.rowsPerPage + 2 ? Math.ceil(pagination.totalItems / pagination.rowsPerPage) : pagination.rowsPerPage + 2"
                      circle/>
                  </v-flex>

                </v-layout>
              </div>
            </template>
            <v-layout
              row
              justify-center
              fill-width
              text-xs-center
              wrap
              block>
              <v-flex md12>
                <vue-excel-xlsx
                  ref="excel"
                  :data="contentExcel"
                  :columns="headersFilter"
                  :filename="'report'"
                  :sheetname="'Diet BR-Corte'"
                  style="display:none!important;background-color: green; color: #fff; padding: 10px; margin:auto;"
                >
                  {{ strings[idioma].exporta_excel }}
                </vue-excel-xlsx>
                <v-btn
                  color="success"
                  @click="exportaExcel">
                  {{ strings[idioma].exporta_excel }}
                </v-btn>
              </v-flex>
              <v-flex md12>
                <v-btn
                  :data="dataExcel"
                  :columns="headersFilter"
                  :filename="'report'"
                  :sheetname="'Diet BR-Corte'"

                  @click="dialogExportaPDF = true;"
                >
                  {{ strings[idioma].gerar_pdf }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>

        </v-container>
        <v-dialog
          v-model="dialogExportaPDF"
          width="350"
          height="300"
          transition="dialog-bottom-transition"
        >
          <v-card
            v-if="dialogExportaPDF">
            <v-card-title>
              <v-layout column>
                <span class="headline">{{ strings[idioma].gerar_pdf }}</span>
              </v-layout>
            </v-card-title>
            <v-card
              style="overflow:auto; min-height: 330px; padding: 10px;"
            >
              <v-list>
                <v-layout
                  row
                  wrap>
                  <v-flex
                    md12
                    xs12>
                    <v-select
                      v-model="colunasSelecionadas"
                      :items="filterHeaders"
                      :item-text="'label'"
                      :item-value="'value'"
                      :label="'Colunas'"
                      attach
                      chips
                      multiple
                    />
                    <template v-if="dataSetSel.size === 0">
                      <v-flex>
                        <v-text-field
                          v-if="false"
                          v-model="search"
                          :label="strings[idioma].pesquisar"
                          append-icon="mdi-magnify"
                          single-line
                          hide-details
                        />
                      </v-flex>
                      <v-spacer/>
                      <v-flex md12>
                        <v-text-field
                          v-model="pagination.page"
                          :items="totalItems"
                          :label="'A partir da página'"
                          small/>
                      </v-flex>
                      <v-spacer/>
                      <v-flex md12>
                        <v-text-field
                          v-model="pagination.limit"
                          :items="totalItems"
                          :label="'Quantidades de dados'"
                          small/>
                      </v-flex>
                    </template>

                </v-flex></v-layout>
              </v-list>
            </v-card>
            <v-card-actions>
              <v-spacer/>
              <v-btn
                color="success"
                @click="exportaPDF()"
              >
                <v-icon
                  left
                  dark>mdi-arrow-down-bold-circle-outline</v-icon>
                {{ strings[idioma].exporta }}
              </v-btn>
              <v-btn
                color="error"
                @click="dialogExportaPDF = false"
              >
                <v-icon
                  left
                  dark>mdi-close</v-icon>
                {{ strings[idioma].fechar }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { getData, getDataEmpresa, updateData, getVinculados, getDietasNaoVinculados, getNaoVinculados, groupBy } from '@/utils/utils'
import Topo from './Topo'
import moment from 'moment'
import VueExcelXlsx from 'vue-excel-xlsx/VueExcelXlsx'

import {
  CRESCIMENTO_TERMINACAO,
  VACA,
  NAO_GESTANTE
} from '@/utils/types.js'
import {
  replaceSpecialChars
} from '@/utils/vuex'

export default {

  components: {
    Topo
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    empresa: Object
  },

  data () {
    return {

      exportando_dados: false,
      totalItems: [5, 10, 15, 20, 25],
      dialogExportaPDF: false,
      backdoor: 0,
      pagination: {
        rowsPerPage: 5,
        sortBy: null,
        descending: false,
        page: 1,
        totalItems: 0,
        limit: 250
      },
      relatorioFinanceiroEstrutura: {
        'IAE': {
          'N': {
            'unidadeEsq': [
              '',
              ''
            ],
            'title': [
              'Número de Animais',
              'Number of Animals'
            ],
            'valor': 0,
            'inteiro': true
          },
          'DCONF': {
            'unidadeEsq': [
              '',
              ''
            ],
            'title': [
              'Dias de Operação',
              'Days of Operation'
            ],
            'valor': 0,
            'inteiro': true
          },
          'PESO_DE_VENDA': {
            'unidadeDir': [
              '',
              ''
            ],
            'title': [
              'Peso de Venda (@)',
              'Selling Weight (@)'
            ],
            'valor': 0
          },
          'TAP': {
            'unidadeDir': [
              '',
              ''
            ],
            'title': [
              'Total de Arrobas Produzidas (@)',
              'Total Arrobas Produced (@)'
            ],
            'valor': 0
          },
          'GDC': {
            'unidadeDir': [
              '',
              ''
            ],
            'title': [
              'Ganho de Carcaça Total (@)',
              'Total Carcass Gain (@)'
            ],
            'valor': 0
          },
          'CUSTO_DIARIO': {
            'unidadeEsq': [
              'R$',
              '$'
            ],
            'title': [
              'Custo Diário (R$/Cab.)',
              'Daily Cost ($/Head)'
            ],
            'valor': 0
          },
          'COCAB': {
            'unidadeEsq': [
              'R$',
              '$'
            ],
            'title': [
              'Custo Operacional (R$/Cab.)',
              'Operational Cost ($/Head)'
            ],
            'valor': 0
          },
          'CAR': {
            'unidadeDir': [
              '',
              ''
            ],
            'title': [
              'Custo de Alimentação / Receita (%)',
              'Food Cost / Revenue (%)'
            ],
            'valor': 0
          },
          'CTR': {
            'unidadeDir': [
              '',
              ''
            ],
            'title': [
              'Custo Operacional / Receita (%)',
              'Operational Cost / Revenue (%)'
            ],
            'valor': 0
          },
          'COT': {
            'unidadeDir': [
              '',
              ''
            ],
            'title': [
              'Custo Total / Receita (%)',
              'Total Cost / Revenue (%)'
            ],
            'valor': 0
          },
          'CAP': {
            'unidadeEsq': [
              'R$',
              '$'
            ],
            'title': [
              'Custo da Arroba Produzida (R$/@)',
              'Cost of the Produced Arroba ($/@)'
            ],
            'valor': 0
          },
          'PONTO_EQUILIBRIO_PRECO': {
            'unidadeEsq': [
              'R$',
              '$'
            ],
            'title': [
              'Ponto de Equilíbrio (R$/@)',
              'Balance Point Price ($/@)'
            ],
            'valor': 0
          },
          'CUSTO_OPORTUNIDADE_CAPITAL': {
            'unidadeEsq': [
              'R$',
              '$'
            ],
            'title': [
              'Custo de Oportunidade de Capítal - Juros (R$/Cab.)',
              'Capital Opportunity Cost ($/Head)'
            ],
            'valor': 0
          },
          'PONTO_EQUILIBRIO_PRECO_COP': {
            'unidadeEsq': [
              'R$',
              '$'
            ],
            'title': [
              'Ponto de Equilíbrio com Juros (R$/@)',
              'Equilibrium Point with Interest ($/@)'
            ],
            'valor': 0
          },
          'MARGEM_OPERACIONAL': {
            'unidadeEsq': [
              'R$',
              '$'
            ],
            'title': [
              'Margem Operacional (R$/@)',
              'Operating Margin ($/@)'
            ],
            'valor': 0
          },
          'MARGEM_OPERACIONAL_CAB': {
            'unidadeEsq': [
              'R$',
              '$'
            ],
            'title': [
              'Margem Operacional (R$/Cab.)',
              'Operating Margin (R$/Head)'
            ],
            'valor': 0
          },
          'RAT': {
            'unidadeEsq': [
              'R$',
              '$'
            ],
            'title': [
              'Lucro por Animal (R$/Cab.)',
              'Earnings per animal ($/Head)'
            ],
            'valor': 0
          },
          'TAXA_RETORNO_INVESTIMENTO_ANO': {
            'unidadeDir': [
              '',
              ''
            ],
            'title': [
              'Taxa de Retorno do Investimento (% a.a.)',
              'Rate of Return on Investment (% yoy)'
            ],
            'valor': 0
          },
          'TAXA_RETORNO_INVESTIMENTO_ANO_COP': {
            'unidadeDir': [
              '',
              ''
            ],
            'title': [
              'Taxa de Retorno do Investimento com Juros (% a.a.)',
              'Return on Investment Rate with Interest (% yoy)'
            ],
            'valor': 0
          }
        },
        'ATC': {
          'IA': {
            'unidadeEsq': [
              'R$',
              '$'
            ],
            'title': [
              'Investimento em Animais (R$)',
              'Animal Purchase Cost ($)'
            ],
            'valor': 0
          },
          'CALT': {
            'unidadeEsq': [
              'R$',
              '$'
            ],
            'title': [
              'Custo com Alimentação (R$)',
              'Cost with Food ($)'
            ],
            'valor': 0
          },
          'OC': {
            'unidadeEsq': [
              'R$',
              '$'
            ],
            'title': [
              'Custos Extras (R$)',
              'Extra Costs ($)'
            ],
            'valor': 0
          },
          'CT': {
            'unidadeEsq': [
              'R$',
              '$'
            ],
            'title': [
              'Custo Operacional (R$)',
              'Operational Cost ($)'
            ],
            'valor': 0
          },
          'RBT': {
            'unidadeEsq': [
              'R$',
              '$'
            ],
            'title': [
              'Receita Bruta (R$)',
              'Total Revenue (R$)'
            ],
            'valor': 0
          },
          'RTA': {
            'unidadeEsq': [
              'R$',
              '$'
            ],
            'title': [
              'Margem Bruta Total (R$)',
              'Total Gross Margin ($)'
            ],
            'valor': 0
          },
          'RTPAA': {
            'unidadeEsq': [
              'R$',
              '$'
            ],
            'title': [
              'Receita Total com Preço de Arrobas Adquiridas (R$)',
              'Total Revenue with Price of Purchased Arrobes ($)'
            ],
            'valor': 0
          }
        }
      },
      search: '',
      columns: [],
      headers: [],
      colunasSelecionadas: [],
      dataExcel: [],
      dataWeb: [],
      dataSetSel: new Set(),
      linkURL: null,
      loadingAlimentos: false,
      searchDieta: null,
      searchEmpresas: null,
      searchPredicao: null,
      searchTabela: null,
      dietasCarregadas: null,
      empresas: null,
      currUser: null,
      logo: 'img/brcorte-logo.png',
      tiposUsuarios: [],
      usuariosSelecionados: [],
      tiposAnimais: [],
      tiposDieta: [],
      headersHidden: [],
      dataInicial: null,
      dataFinal: null,
      dataFinalTest: null,
      dietasAtivas: false,
      dietasFinalizadas: false,
      predicoes: false,
      dietasNaoVinculados: false
    }
  },
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user', 'ingredientes', 'optionsNumber', 'alimentos_selecionados', 'categorias_alimentos', 'alert', 'dietas', 'tabelas', 'vinculados']),
    numberOfPages () {
      return Math.ceil(this.dataWeb.length / this.itemsPerPage)
    },
    filteredKeys () {
      return this.keys.filter(key => key !== `Name`)
    },
    binding () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndUp) binding.row = true
      else binding.row = false
      return binding
    },
    chartOptions () {
      return {
        legend: {
          position: 'none'
        },
        chart: {
          responsive: true,
          legend: {
            position: 'none'
          }
        }
      }
    },
    filterItems () {
      return this.Cargos
    },
    filterHeaders () {
      return this.headers
    },
    filterUsers () {
      // não permitir o filtro por produtores
      if (this.user.permissao === 0 || (this.user.emp_user && this.user.emp_user.acesso === 0)) return this.vinculados
      return (this.vinculados !== null) ? this.vinculados.filter(v => this.user.permissao === 0 || (v.emp_user.acesso < 4 && v.emp_user.acesso > this.user.emp_user.acesso)) : []
    },
    filter () {
      return (item, search, textKey) => item[textKey].toLowerCase().search(search.toLowerCase()) > -1
    },
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 150) + 'px'
    },
    widthCard () {
      return String(this.$vuetify.breakpoint.width - 300) + 'px'
    },
    heightDialog () {
      return this.$vuetify.breakpoint.xs ? String(this.$vuetify.breakpoint.height - 150) + 'px' : String(this.$vuetify.breakpoint.height - 240) + 'px'
    },
    heightOverflow () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 50) + 'px; overflow: auto;'
    },
    heightTree () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 200) + 'px; overflow: auto; min-height: 200px;'
    },
    contentExcel () {
      this.backdoor
      return this.dataExcel.filter(d => Array.from(this.dataSetSel).includes(d.id) || this.dataSetSel.size === 0)
    },
    Cargos () {
      return [
        { 'nome': this.strings[this.idioma]['empresa_gestor'], 'nivel': 0, 'id': 'empresa_gestor' },
        { 'nome': this.strings[this.idioma]['empresa_gerente_regional'], 'nivel': 1, 'id': 'empresa_gerente_regional' },
        { 'nome': this.strings[this.idioma]['empresa_tecnico_venda'], 'nivel': 2, 'id': 'empresa_tecnico_venda' },
        { 'nome': this.strings[this.idioma]['empresa_produtor_vinculado'], 'nivel': 3, 'id': 'empresa_produtor_vinculado' }

      ].filter(c => (this.user.permissao === 0 || c.nivel > this.user.emp_user.acesso || this.user.emp_user.acesso === 0))
    },
    filterTipos () {
      return [
        { 'nome': this.strings[this.idioma]['crescimento_terminacao'], 'nivel': 0, 'id': 'crescimento_terminacao' },
        { 'nome': this.strings[this.idioma]['vaca'], 'nivel': 1, 'id': 'vaca' },
        { 'nome': this.strings[this.idioma]['bezerro'], 'nivel': 2, 'id': 'bezerro' }

      ]
    },
    filterTipoDieta () {
      return [
        { 'nome': this.strings[this.idioma]['formulacao_dietas'], 'nivel': 0, 'id': 'formulacao_dietas' },
        { 'nome': this.strings[this.idioma]['predicao_desempenho'], 'nivel': 1, 'id': 'predicao_desempenho' }
      ]
    },
    headersFilter () {
      return this.headers.filter(h => !this.headersHidden.includes(h.text))
    },
    Dietas () {
      let d = Array.from(this.dietas)
      if (d === null) return []
      d.reverse()
      return d
    },
    dietasFilter () {
      let users = this.vinculados === null ? [] : this.vinculados
      let dietas = this.dietas === null ? [] : this.Dietas
      if (dietas === null) return dietas
      if (this.dietasNaoVinculados) {
        if (this.predicoes !== null && this.predicoes) dietas = dietas.filter(d => d.tipo_dieta === 1)
        if (this.dietasAtivas !== null && this.dietasAtivas) dietas = dietas.filter(d => d.ativa)
        if (this.tiposAnimais !== null && this.tiposAnimais.length > 0) dietas = dietas.filter(d => d.dieta && this.tiposAnimais.includes(this.strings[this.idioma][d.animal.tipo]))
        return dietas
      }

      if (this.dietasAtivas !== null && this.dietasAtivas) dietas = dietas.filter(d => d.ativa && d.dieta_ativa && d.dieta_ativa.data_fim_real === null)
      if (this.dietasFinalizadas !== null && this.dietasFinalizadas) dietas = dietas.filter(d => d.ativa && d.dieta_ativa && d.dieta_ativa.data_fim_real !== null)
      if (this.predicoes !== null && this.predicoes) dietas = dietas.filter(d => d.tipo_dieta === 1)
      if (dietas === null) return dietas

      if (this.tiposUsuarios !== null && this.tiposUsuarios.length > 0) users = users.filter(u => this.tiposUsuarios.includes((this.Cargos.filter(c => u.emp_user.acesso === c.nivel)[0]) ? this.Cargos.filter(c => u.emp_user.acesso === c.nivel)[0].nome : ''))
      if (this.usuariosSelecionados !== null && this.usuariosSelecionados.length > 0) users = users.filter(u => this.usuariosSelecionados.includes(u.email))
      let usersId = users.map(u => u.id)
      if (this.tiposAnimais !== null && this.tiposAnimais.length > 0) dietas = dietas.filter(d => d.animal && this.tiposAnimais.includes(this.strings[this.idioma][d.animal.tipo]))
      if (this.tiposDieta !== null && this.tiposDieta.length > 0) dietas = dietas.filter(d => d.tipo_alimento_predicao)
      return dietas.filter(d => (usersId.includes(d.user_id)))
    },
    dietasFilter2 () {
      if (this.dietas === null) return this.dietas
      if ((this.usuariosSelecionados === [] || this.usuariosSelecionados === null || this.usuariosSelecionados.length === 0) && (this.tiposUsuarios === [] || this.tiposUsuarios === null || this.tiposUsuarios.length === 0)) return this.dietas.filter(u => (u.animal && u.animal.tipo && (u.animal.tipo !== '' && u.animal.tipo !== null)) || (this.tiposAnimais.length > 0 && this.tiposAnimais.includes(this.strings[this.idioma][u.animal.tipo])))
      let users = this.vinculados
      let usersId = users.filter(u => this.tiposUsuarios.includes(this.Cargos.filter(c => u.emp_user.acesso === c.nivel)[0].nome)).map(u => u.id)
      if (!(this.usuariosSelecionados === [] || this.usuariosSelecionados === null || this.usuariosSelecionados.length === 0)) { usersId = [...usersId, ...users.filter(u => this.usuariosSelecionados.includes(u.email)).map(u => u.id)] }
      return this.dietas.filter(d => (usersId.includes(d.user_id) && d.animal && d.animal.tipo && (d.animal.tipo !== '' && d.animal.tipo !== null)) || (this.tiposAnimais.length > 0 && this.tiposAnimais.includes(this.strings[this.idioma][d.animal.tipo])))
    },
    dietasSexoAnimais () {
      const dietas = this.dietasFilter
      let animais = dietas.map(d => d.animal)
      let tipos = {}
      for (let animal of animais) {
        if (animal.tipo !== 'crescimento_terminacao') continue
        if (!tipos[animal.sexo]) {
          tipos[animal.sexo] = { count: 0, name: this.strings[this.idioma][animal.sexo] }
        }
        tipos[animal.sexo].count++
      }
      let dados = [['Animal', 'Quantidade']]
      for (let a of Object.values(tipos)) {
        dados.push([a.name, a.count])
      }
      return dados
    },
    dietasGrupoAnimais () {
      const dietas = this.dietasFilter
      let animais = dietas.map(d => d.animal)
      let tipos = {}
      for (let animal of animais) {
        if (animal.tipo !== 'crescimento_terminacao') continue
        if (!tipos[animal.raca]) {
          tipos[animal.raca] = { count: 0, name: this.strings[this.idioma][animal.raca] }
        }
        tipos[animal.raca].count++
      }
      let dados = [['Animal', 'Quantidade']]
      for (let a of Object.values(tipos)) {
        dados.push([a.name, a.count])
      }
      return dados
    },
    dietasRegimeAnimais () {
      const dietas = this.dietasFilter
      let animais = dietas.map(d => d.animal)
      let tipos = {}
      for (let animal of animais) {
        if (animal.tipo !== 'crescimento_terminacao') continue
        if (!tipos[animal.regime]) {
          tipos[animal.regime] = { count: 0, name: this.strings[this.idioma][animal.regime] }
        }
        tipos[animal.regime].count++
      }
      let dados = [['Animal', 'Quantidade']]
      for (let a of Object.values(tipos)) {
        dados.push([a.name, a.count])
      }
      return dados
    },
    dietasAlimentos () {
      const alimentosSt = JSON.parse(localStorage.getItem('alimentosStored'))
      const dietas = this.dietasFilter
      let MN = dietas.map(d => d.resultado)
      let alimentos = {}
      for (let dieta of MN) {
        for (let a in dieta) {
          if (a === 'ID_LEITE_VACA') a = '0-0|0|0'
          if (!alimentosSt[a]) continue
          if (!alimentos[a]) {
            if (alimentosSt[a]) {
              alimentos[a] = { count: 0, name: (this.idioma === 0) ? alimentosSt[a].name : alimentosSt[a].name_en }
            }
          }
          alimentos[a].count++
        }
      }
      alimentos = Object.values(alimentos).sort((a, b) => a.count > b.count ? -1 : (a.count === b.count) ? 0 : 1).slice(0, 10)
      let dados = [['Alimento', 'Quantidade']]
      for (let a of Object.values(alimentos)) {
        dados.push([a.name, a.count])
      }
      return dados
    },
    dietasAnimais () {
      const dietas = this.dietasFilter
      let animais = dietas.map(d => d.animal)
      let tipos = {}
      for (let animal of animais) {
        if (!tipos[animal.tipo]) {
          tipos[animal.tipo] = { count: 0, name: this.strings[this.idioma][animal.tipo] }
        }
        tipos[animal.tipo].count++
      }
      let dados = [['Animal', 'Quantidade']]
      for (let a of Object.values(tipos)) {
        dados.push([a.name, a.count])
      }
      return dados
    },
    predicoesFilter () {
      if (this.searchPredicao === null || this.searchPredicao.trim() === '') return this.predicoes
      return this.predicoes.filter(u => new RegExp(replaceSpecialChars(this.searchPredicao.toLowerCase()), 'i').test(u.nome ? u.nome : u.name))
    },
    tabelasFilter () {
      if (this.searchTabela === null || this.searchTabela.trim() === '') return this.tabelas
      return this.tabelas.filter(u => new RegExp(replaceSpecialChars(this.searchTabela.toLowerCase()), 'i').test(u.nome ? u.nome : u.name))
    },
    empresasFilter () {
      if (this.searchEmpresas === null || this.searchEmpresas.trim() === '') return this.empresas
      return this.empresas.filter(u => new RegExp(replaceSpecialChars(this.searchEmpresas.toLowerCase()), 'i').test(u.nome))
    }
  },
  watch: {
    'dietasNaoVinculados' (val) {
      this.getData().then(_ => {
        this.dataAdapter()
      })
    },
    'dataFinalTest' (val) {
      this.dataFinal = moment(val).add('days', 1).startOf('day').format('YYYY-MM-DD')
    },

    'dietasFilter' (val) {
      this.dataAdapter()
      this.pagination.totalItems = val.length
      this.backdoor++
    },
    'idioma' (val) {
      window.location.reload()
    },
    'dataSetSel' (val) {
      this.backdoor++
    },
    'colunasSelecionadas' (val) {
      if (val !== null && val.length > 12) alert('Não é recomendavel selecionar mais que 12 itens')
    }
  },
  created () {
    this.dataFinal = moment().startOf('day').format('YYYY-MM-DD')
    this.dataFinalTest = moment().startOf('day').format('YYYY-MM-DD')
    this.dataInicial = moment(this.dataFinal).subtract(2, 'month').startOf('day').format('YYYY-MM-DD')
    this.queryWork()
    this.exportando_dados = true

    if (this.user.permissao !== 0) {
      if (this.user.emp_user === null) this.voltar()
      this.selecionaEmpresa(this.user.empresa_vinculada[0]).then(() => {
        this.exportando_dados = false
      })
    }
    this.axios.post('empresa/getEmpresas', {}).then(r => {
      this.exportando_dados = true
      this.empresas = r.data.data.empresas
      this.getData().then(() => {
        getVinculados(this.$store.state, this.empresa.id, this.axios, { dataInicial: this.dataInicial, dataFinal: this.dataFinal }).then(r => {
          this.dataAdapter()
          this.exportando_dados = false
        })
      })
    }).catch(() => {
      console.log('/')
      this.exportando_dados = false
    })
    if (!this.categorias_alimentos) {
      this.loadAlimentosDieta()
    }
  },
  methods: {
    reload () {
      return this.getData().then(_ => {
        this.dataAdapter()
      })
    },
    desselecionarTodos () {
      this.dataAdapter()
      this.dataSetSel.clear()
    },
    selecionaItem (item) {
      item.selecionado = !item.selecionado
      if (item.selecionado) {
        this.dataSetSel.add(item.id)
      } else {
        this.dataSetSel.delete(item.id)
      }
      console.log(this.dataSetSel)
    },
    exportaPDF () {
      const exporta = () => {
        this.exportando_dados = true
        this.page = this.pagination.page
        this.itemsPerPage = this.pagination.rowsPerPage
        let headers = this.headersFilter.filter((h, i) => (this.colunasSelecionadas.length === 0 && i < 13) || (this.colunasSelecionadas.length > 0 && this.colunasSelecionadas.includes(h.value)))
        let content = this.dataExcel
        if (this.dataSetSel.size > 0) {
          content = content.filter(d => Array.from(this.dataSetSel).includes(d.id))
        } else {
          content = content.filter(d => (this.dataSetSel.size === 0) || (Array.from(this.dataSetSel).includes(d.id))).slice(((this.page - 1) * this.itemsPerPage), ((this.page - 1) * this.itemsPerPage) + this.pagination.limit)
        }
        this.axios.post('relatorios/genericTable', { 'idioma': this.idioma, 'title': this.strings[this.idioma].relatorios, 'content': content, 'header': headers }).then(res => {
          let link = document.createElement('a')
          link.href = res.data.pdf
          link.target = '_blank'
          let win = window.open(link.href, link.target)
          if (!win || win === null) {
            link.click()
            let msg = link.href
            let title = 'Download Link'
            this.$copyText(msg)
            msg = '<textarea readonly style="width: 100%; height: 200px;" value="' + msg + '">' + msg + '</textarea>'
            this.$store.commit('openOKModal', { title, msg })
          }
          this.exportando_dados = false
        }).catch(res => {
          this.exportando_dados = false
        })
      }
      this.dialogExportaPDF = false
      setTimeout(() => {
        exporta()
      }, 100)
    },
    exportaExcel () {
      this.$refs.excel._props.data = this.$refs.excel._props.data.filter(d => this.dataSetSel.size === 0 || Array.from(this.dataSetSel).includes(d.id))
      this.$refs.excel.exportExcel()
    },
    nextPage () {
      if (this.page + 1 <= this.numberOfPages) this.page += 1
    },
    formerPage () {
      if (this.page - 1 >= 1) this.page -= 1
    },
    updateItemsPerPage (number) {
      this.itemsPerPage = number
    },
    relatorioFinanceiro (animal, custo) {
      let relatorioFinanceiro = {
      'IAE': {
        'N': {
          'unidadeEsq': [
            '',
            '',
            ''
          ],
          'title': [
            'Número de Animais',
            'Number of Animals',
            'Número de Animales'
          ],
          'valor': 0,
          'inteiro': true,
          'livre': true
        },
        'DCONF': {
          'unidadeEsq': [
            '',
            '',
            ''
          ],
          'title': [
            'Dias de Operação',
            'Days of Operation',
            'Días de funcionamiento'
          ],
          'valor': 0,
          'inteiro': true,
          'livre': true
        },
        'PESO_DE_VENDA': {
          'unidadeDir': [
            '',
            '',
            ''
          ],
          'title': [
            'Peso de Venda (@)',
            'Selling Weight (@)',
            'Peso de Venta (@)'
          ],
          'valor': 0
        },
        'TAP': {
          'unidadeDir': [
            '',
            '',
            ''
          ],
          'title': [
            'Total de Arrobas Produzidas (@)',
            'Total Arrobas Produced (@)',
            'Total de Arrobas Producidas (@)'
          ],
          'valor': 0,
          'livre': true
        },
        'GDC': {
          'unidadeDir': [
            '',
            '',
            ''
          ],
          'title': [
            'Ganho de Carcaça Total (@)',
            'Total Carcass Gain (@)',
            'Ganancia Total de la Canal (@)'
          ],
          'valor': 0
        },
        'RG': {
          'unidadeDir': [
            '',
            '',
            ''
          ],
          'title': [
            'Rendimento do Ganho (%)',
            'Gain Yield (@)',
            'Rendimiento de Ganancias (%)'
          ],
          'valor': 0
        },
        'GDiarioC': {
          'unidadeDir': [
            '',
            '',
            ''
          ],
          'title': [
            'Ganho Diário de Carcaça (kg/dia)',
            'Daily Carcass Gain  (kg/day)',
            'Ganancia Diaria de Canal (kg/día)'
          ],
          'valor': 0
        },

        'EFICIENCIA_BIOLOGICA': {
          'unidadeDir': [
            '',
            '',
            ''
          ],
          'title': [
            'Eficiência Biológica (Kg de MS/ @ de carcaça)',
            'Biological Efficiency (Kg of DM/ @ of carcass)',
            'Eficiencia Biológica (Kg de MS / @ de canal)'
          ],
          'valor': 0
        },
        'CUSTO_DIARIO': {
          'unidadeEsq': [
            'R$',
            '$',
            '$'
          ],
          'title': [
            'Custo Diário (R$/Cab.)',
            'Daily Cost ($/Head)',
            'Costo Diario ($/Cabeza)'
          ],
          'valor': 0
        },
        'COCAB': {
          'unidadeEsq': [
            'R$',
            '$',
            '$'
          ],
          'title': [
            'Custo Operacional (R$/Cab.)',
            'Operational Cost ($/Head)',
            'Costo Operativo ($/Cabeza)'
          ],
          'valor': 0
        },
        'CAR': {
          'unidadeDir': [
            '',
            '',
            ''
          ],
          'title': [
            'Custo de Alimentação / Receita (%)',
            'Food Cost / Revenue (%)',
            'Costo de alimentos / Ingresos (%)'
          ],
          'valor': 0,
          'livre': true
        },
        'CTR': {
          'unidadeDir': [
            '',
            '',
            ''
          ],
          'title': [
            'Custo Operacional / Receita (%)',
            'Operational Cost / Revenue (%)',
            'Costo Operacional / Ingresos (%)'
          ],
          'valor': 0
        },
        'COT': {
          'unidadeDir': [
            '',
            '',
            ''
          ],
          'title': [
            'Custo Total / Receita (%)',
            'Total Cost / Revenue (%)',
            'Costo Total / Ingresos (%)'
          ],
          'valor': 0,
          'livre': true
        },
        'CAP': {
          'unidadeEsq': [
            'R$',
            '$',
            '$'
          ],
          'title': [
            'Custo da Arroba Produzida (R$/@)',
            'Cost of the Produced Arroba ($/@)',
            'Costo de la Arroba Producida ($/@)'
          ],
          'valor': 0
        },
        'PONTO_EQUILIBRIO_PRECO': {
          'unidadeEsq': [
            'R$',
            '$',
            '$'
          ],
          'title': [
            'Ponto de Equilíbrio (R$/@)',
            'Balance Point Price ($/@)',
            'Precio del punto de equilibrio ($/@)'
          ],
          'valor': 0
        },
        'CUSTO_OPORTUNIDADE_CAPITAL': {
          'unidadeEsq': [
            'R$',
            '$',
            '$'
          ],
          'title': [
            'Custo de Oportunidade de Capítal - Juros (R$/Cab.)',
            'Capital Opportunity Cost ($/Head)',
            'Costo de Oportunidad de Capital ($/Cabeza)'
          ],
          'valor': 0
        },
        'PONTO_EQUILIBRIO_PRECO_COP': {
          'unidadeEsq': [
            'R$',
            '$',
            '$'
          ],
          'title': [
            'Ponto de Equilíbrio com Juros (R$/@)',
            'Equilibrium Point with Interest ($/@)',
            'Punto de Equilibrio con Interés ($/@)'
          ],
          'valor': 0
        },
        'MARGEM_OPERACIONAL': {
          'unidadeEsq': [
            'R$',
            '$',
            '$'
          ],
          'title': [
            'Margem Operacional (R$/@)',
            'Operating Margin ($/@)',
            'Margen Operativo ($/@)'
          ],
          'valor': 0
        },
        'MARGEM_OPERACIONAL_CAB': {
          'unidadeEsq': [
            'R$',
            '$',
            '$'
          ],
          'title': [
            'Margem Operacional (R$/Cab.)',
            'Operating Margin (R$/Head)',
            'Margen Operativo (R$/Cabeza)'
          ],
          'valor': 0
        },
        'RAT': {
          'unidadeEsq': [
            'R$',
            '$',
            '$'
          ],
          'title': [
            'Lucro por Animal (R$/Cab.)',
            'Earnings per animal ($/Head)',
            'Ganancias por animal ($/Cabeza)'
          ],
          'valor': 0
        },
        'TAXA_RETORNO_INVESTIMENTO_ANO': {
          'unidadeDir': [
            '',
            '',
            ''
          ],
          'title': [
            'Taxa de Retorno do Investimento (% a.a.)',
            'Rate of Return on Investment (% yoy)',
            'Tasa de Retorno de la Inversión (% i.a.)'
          ],
          'valor': 0
        },
        'TAXA_RETORNO_INVESTIMENTO_ANO_COP': {
          'unidadeDir': [
            '',
            '',
            ''
          ],
          'title': [
            'Taxa de Retorno do Investimento com Juros (% a.a.)',
            'Return on Investment Rate with Interest (% yoy)',
            'Tasa de Retorno de la Inversión con Interés (% i.a.)'
          ],
          'valor': 0
        }
      },
      'ATC': {
        'IA': {
          'unidadeEsq': [
            'R$',
            '$',
            '$'
          ],
          'title': [
            'Investimento em Animais (R$)',
            'Animal Purchase Cost ($)',
            'Costo de Compra de Animales ($)'
          ],
          'valor': 0
        },
        'CALT': {
          'unidadeEsq': [
            'R$',
            '$',
            '$'
          ],
          'title': [
            'Custo com Alimentação (R$)',
            'Cost with Food ($)',
            'Costo con Alimentos ($)'
          ],
          'valor': 0,
          'livre': true
        },
        'OC': {
          'unidadeEsq': [
            'R$',
            '$',
            '$'
          ],
          'title': [
            'Custos Extras (R$)',
            'Extra Costs ($)',
            'Costos Adicionales ($)'
          ],
          'valor': 0
        },
        'CT': {
          'unidadeEsq': [
            'R$',
            '$',
            '$'
          ],
          'title': [
            'Custo Operacional (R$)',
            'Operational Cost ($)',
            'Costo Operativo ($)'
          ],
          'valor': 0
        },
        'RBT': {
          'unidadeEsq': [
            'R$',
            '$',
            '$'
          ],
          'title': [
            'Receita Bruta (R$)',
            'Total Revenue (R$)',
            'Ingresos Totales (R$)'
          ],
          'valor': 0,
          'livre': true
        },
        'RTA': {
          'unidadeEsq': [
            'R$',
            '$',
            '$'
          ],
          'title': [
            'Margem Bruta Total (R$)',
            'Total Gross Margin ($)',
            'Margen Bruto Total ($)'
          ],
          'valor': 0
        },
        'RTPAA': {
          'unidadeEsq': [
            'R$',
            '$',
            '$'
          ],
          'title': [
            'Receita Total com Preço de Arrobas Adquiridas (R$)',
            'Total Revenue with Price of Purchased Arrobes ($)',
            'Ingresos Totales con Precio de Arrobes Comprados ($)'
          ],
          'valor': 0,
          'livre': true
        }
      }
    }
      if ((animal.tipo === CRESCIMENTO_TERMINACAO || (animal.tipo === VACA && animal.estado_fisiologico === NAO_GESTANTE)) && animal.peso_corporal_inicial && animal.tipo) {
        animal.numero_animais = (!animal.numero_animais) ? 1 : animal.numero_animais
        if (animal.numero_animais > 0 && animal.preco_venda_arroba > 0 && animal.preco_arroba_adquirida > 0 && animal.rendimento_carcaca_inicial > 0 && animal.rendimento_carcaca_final > 0) {
          const precoArrobaAdquirida = animal.preco_arroba_adquirida
          const precoVendaArroba = animal.preco_venda_arroba
          const custoRacao = custo
          const GMD = animal.ganho_medio_diario
          const PCI = (animal.peso_corporal_inicial) ? animal.peso_corporal_inicial : animal.peso_corporal_medio
          const PCF = animal.peso_corporal_final ? animal.peso_corporal_final : animal.peso_corporal_medio
          const RCI = parseFloat(animal.rendimento_carcaca_inicial / 100)
          const RCF = parseFloat(animal.rendimento_carcaca_final / 100)
          const N = animal.numero_animais

          const cmo = animal.custo_mao_de_obra
          const cen = animal.custo_energia
          const cmaq = animal.custo_maquinario
          const cmed = animal.custo_medicamentos
          const cex = animal.custo_extra
          const taxaJurosMes = animal.taxa_juros_mensal
          const outrosCustosDia = ((cmo + cen + cmaq + cmed + cex) / 30.42) / N

          const IA = ((PCI * RCI) / 15) * N * precoArrobaAdquirida
          const pesoDeVenda = ((PCF * RCF) / 15)
          const DCONF = Math.abs(PCI - PCF) / GMD
          const TAP = (((PCF - PCI) * RCF) / 15)
          const GDC = (((PCF * RCF) - (PCI * RCI)) / 15)
          const custoAlimentacao = custoRacao * DCONF
          const RBT = pesoDeVenda * precoVendaArroba
          const CAR = (custoAlimentacao / RBT) * 100
          const custoDiario = custoRacao + outrosCustosDia
          const custoOperacionalCAB = custoDiario * DCONF
          const CTR = (custoOperacionalCAB / RBT) * 100
          const CAP = (custoOperacionalCAB / TAP)
          // --------
          const custoCompra = ((PCI * RCI) / 15) * precoArrobaAdquirida
          const COEFFinal = custoCompra + custoOperacionalCAB
          const pontoEquilibrioPreco = COEFFinal / pesoDeVenda

          const custoOportunidadeCapital = (custoCompra * Math.pow(1 + (taxaJurosMes / 100), (DCONF / 30.42)) - custoCompra) + ((custoOperacionalCAB / 2) * Math.pow(1 + (taxaJurosMes / 100), (DCONF / 30.42)) - (custoOperacionalCAB / 2))
          const pontoEquilibrioPrecoCOP = (COEFFinal + custoOportunidadeCapital) / pesoDeVenda
          const margemOperacional = precoVendaArroba - CAP
          const margemOperacionalCAB = margemOperacional * TAP
          const lucroCAB = RBT - COEFFinal - custoOportunidadeCapital
          const taxaRetornoInvestimentoAno = (Math.pow((((pesoDeVenda * precoVendaArroba)) / (COEFFinal)), (1 / (DCONF / 365))) - 1) * 100
          const taxaRetornoInvestimentoAnoCOP = (Math.pow(((((pesoDeVenda * precoVendaArroba) - custoOportunidadeCapital)) / (COEFFinal)), (1 / (DCONF / 365))) - 1) * 100
          const receitaTotalAProduzida = ((((PCI * RCF / 15) - (PCI * RCI / 15)) * precoVendaArroba) + (((PCI * RCI) / 15 * (precoVendaArroba - precoArrobaAdquirida)))) * N

          relatorioFinanceiro.IAE.N.valor = parseInt(N)
          relatorioFinanceiro.IAE.DCONF.valor = parseInt(DCONF)
          relatorioFinanceiro.IAE.PESO_DE_VENDA.valor = parseFloat(pesoDeVenda)
          relatorioFinanceiro.IAE.TAP.valor = TAP
          relatorioFinanceiro.IAE.GDC.valor = GDC
          relatorioFinanceiro.IAE.CUSTO_DIARIO.valor = custoDiario
          relatorioFinanceiro.IAE.COCAB.valor = custoOperacionalCAB
          relatorioFinanceiro.IAE.CAR.valor = CAR
          relatorioFinanceiro.IAE.CTR.valor = CTR
          relatorioFinanceiro.IAE.COT.valor = ((COEFFinal / RBT) * 100)
          relatorioFinanceiro.IAE.CAP.valor = CAP
          relatorioFinanceiro.IAE.PONTO_EQUILIBRIO_PRECO.valor = pontoEquilibrioPreco
          relatorioFinanceiro.IAE.CUSTO_OPORTUNIDADE_CAPITAL.valor = custoOportunidadeCapital
          relatorioFinanceiro.IAE.PONTO_EQUILIBRIO_PRECO_COP.valor = pontoEquilibrioPrecoCOP
          relatorioFinanceiro.IAE.MARGEM_OPERACIONAL.valor = margemOperacional
          relatorioFinanceiro.IAE.MARGEM_OPERACIONAL_CAB.valor = margemOperacionalCAB
          relatorioFinanceiro.IAE.RAT.valor = lucroCAB
          relatorioFinanceiro.IAE.TAXA_RETORNO_INVESTIMENTO_ANO.valor = taxaRetornoInvestimentoAno
          relatorioFinanceiro.IAE.TAXA_RETORNO_INVESTIMENTO_ANO_COP.valor = taxaRetornoInvestimentoAnoCOP

          const receitaTotal = RBT * N
          const oc = outrosCustosDia * N * DCONF
          const custoOperacional = (custoAlimentacao * N) + oc
          const margemBrutaTotal = receitaTotal - IA - custoOperacional
          relatorioFinanceiro.ATC.IA.valor = IA
          relatorioFinanceiro.ATC.CALT.valor = custoAlimentacao * N
          relatorioFinanceiro.ATC.OC.valor = oc
          relatorioFinanceiro.ATC.CT.valor = custoOperacional
          relatorioFinanceiro.ATC.RBT.valor = receitaTotal
          relatorioFinanceiro.ATC.RTA.valor = margemBrutaTotal
          relatorioFinanceiro.ATC.RTPAA.valor = receitaTotalAProduzida
        }
      }
      return relatorioFinanceiro
    },
    dataAdapter () {
      let header = []
      let data = []
      let data2 = []
      let number = []
      const strings = this.strings
      let h = {
        id: ['#', '#', '#'],
        user_NOME: ['Dono', 'Owner', 'Dueño'],
        user_email: ['E-Mail', 'email', 'email'],
        time: ['Data de Modificação', 'Updated Date', 'Fecha actualizada'],
        tipo: ['Tipo de Animal', 'Animal Type', 'Tipo de animal'],
        peso_corporal_inicial: [strings[0].peso_corporal_inicial, strings[1].peso_corporal_inicial, strings[2].peso_corporal_inicial],
        peso_corporal_final: [strings[0].peso_corporal_final, strings[1].peso_corporal_final, strings[2].peso_corporal_final],
        peso_corporal_medio: [strings[0].peso_corporal_medio, strings[1].peso_corporal_medio, strings[2].peso_corporal_medio],
        ganho_medio_diario: [strings[0].ganho_medio_diario, strings[1].ganho_medio_diario, strings[2].ganho_medio_diario],
        raca: [strings[0].raca, strings[1].raca, strings[2].raca],
        regime: [strings[0].regime, strings[1].regime, strings[2].regime],
        sexo: [strings[0].sexo, strings[1].sexo, strings[2].sexo],
        estado_fisiologico: [strings[0].estado_fisiologico, strings[1].estado_fisiologico, strings[2].estado_fisiologico],
        custo: ['Custo da Dieta (RS/Cab.)', 'Diet Cost ($/Head)', 'Costo de la dieta ($/Cabeza)'],
        proporcao_volumoso: [strings[0].proporcao_vc_dieta, strings[1].proporcao_vc_dieta, strings[2].proporcao_vc_dieta],
        resultado: ['Resultado em MN              ', 'NM Result              ', 'Resultado en MN              ']
      }
      let rfHeader = this.relatorioFinanceiroEstrutura
      for (let rfI in rfHeader) {
        for (let rf in rfHeader[rfI]) {
          h[rf] = rfHeader[rfI][rf].title
          number.push(rf)
        }
      }
      let date = ['time']
      number = [...number, 'peso_corporal_inicial', 'peso_corporal_final', 'peso_corporal_medio', 'ganho_medio_diario', 'custo', 'numero_animais']
      for (let i in h) {
        const aux = {
          text: h[i][this.idioma],
          align: 'left',
          sortable: i !== 'time',
          value: i,
          label: h[i][this.idioma],
          field: i,
          selecionado: false
        }
        header.push(aux)
      }
      // adaptar as dietas carregadas;
      for (let dieta of Object.values(this.dietasFilter)) {
        // dieta = JSON.parse(dieta['dieta'])
        console.log({ dieta })
        let aux = {}
        let aux2 = {}
        let us = this.vinculados.filter(u => u.id === dieta.user_id)[0]
        if (!dieta['animal']) {
          if (!dieta['dieta']) continue
          // caso de dieta não vinculada
          dieta = { ...dieta, ...JSON.parse(dieta['dieta']) }
          us = { 'NOME': dieta['NOME'], 'email': dieta['email'] }
        }
        let financeiro = this.relatorioFinanceiro(dieta['animal'], dieta['custo'])
        aux['selecionado'] = false
        aux2['selecionado'] = false
        for (let i in h) {
          if (i === 'proporcao_volumoso') {
            if (dieta[i] && dieta[i] !== '' && dieta[i] !== null && dieta[i] !== 0) {
              if ((dieta['fixa_proporcao_vc'] === true)) {
                let vc = parseInt(dieta[i])
                dieta[i] = vc + ':' + (100 - vc)
                if (isNaN(vc)) {
                  dieta[i] = '-:-'
                }
              } else {
                dieta[i] = ''
              }
              // dieta[i] = (dieta['fixa_proporcao_vc'] === true) ? (dieta[i] + ':' + (100 - parseInt(dieta[i]))) : null
            }
          }
          if (i === 'resultado') {
            let vals = []
            try {
              vals = dieta[i]
            } catch (ex) {
              continue
            }
            let alimentos = JSON.parse(localStorage.getItem('alimentosStored'))
            let res = '<div style="white-space: nowrap; max-height: 100px!important; overflow: auto;text-overflow: ellipsis;">'
            for (let alid in vals) {
              if (parseFloat(vals[alid]) === 0 || (parseFloat((vals[alid] * 1000) * 1000) <= 0.01)) continue
              res += '<small style="color: red;">' + ((alimentos[alid]) ? alimentos[alid][(this.idioma === 0) ? 'name' : 'name_en'] : alid) + '</small> ->'
              if (parseFloat(vals[alid]) <= 0.001) {
                res += '~ ' + parseFloat((vals[alid] * 1000) * 1000).toFixed(2).replace('.', this.strings[this.idioma].separador_float) + ''

                res += ' mg.</br>'
              } else if (parseFloat(vals[alid]) <= 0.999) {
                res += parseFloat(vals[alid] * 1000).toFixed(2).replace('.', this.strings[this.idioma].separador_float)
                res += ' g.</br>'
              } else {
                res += parseFloat(vals[alid]).toFixed(2).replace('.', this.strings[this.idioma].separador_float)
                res += ' kg.</br>'
              }
            }
            res += '</div>'
            aux2[i] = res
            res = ''
            for (let alid in vals) {
              res += ((alimentos[alid]) ? alimentos[alid][(this.idioma === 0) ? 'name' : 'name_en'] : alid) + ' ->'
              res += parseFloat(vals[alid]).toFixed(2).replace('.', this.strings[this.idioma].separador_float) + ' kg.\n'
            }
            aux[i] = res
          } else if (String(i).match('user_')) {
            aux[i] = us[i.split('_')[1]]
          } else if (number.includes(i)) aux[i] = (parseFloat((dieta['animal'][i]) ? dieta['animal'][i] : dieta[i])).toFixed(2).replace('.', this.strings[this.idioma].separador_float)
          else if (date.includes(i)) aux[i] = moment((dieta['animal'][i]) ? dieta['animal'][i] : dieta[i]).format(this.strings[this.idioma].formato_datas_com_hora)
          else aux[i] = (dieta['animal'][i]) ? dieta['animal'][i] : dieta[i]
          aux[i] = (strings[this.idioma][aux[i]]) ? strings[this.idioma][aux[i]] : aux[i]
          aux[i] = (!aux[i] || String(aux[i]).trim() === '' || aux[i] === null || aux[i] === 'NaN') ? '-' : aux[i]
          if (!aux2[i]) aux2[i] = aux[i]
        }
        for (let f in financeiro) {
          for (let ff in financeiro[f]) {
            aux[ff] = financeiro[f][ff].valor === 0 ? '' : parseFloat(financeiro[f][ff].valor).toFixed(2).replace('.', this.strings[this.idioma].separador_float)
            aux2[ff] = financeiro[f][ff].valor === 0 ? '' : parseFloat(financeiro[f][ff].valor).toFixed(2).replace('.', this.strings[this.idioma].separador_float)
            aux[ff] = (!aux[ff] || String(aux[ff]).trim() === '' || aux[ff] === null || aux[ff] === 'NaN') ? '-' : aux[ff]
            aux2[ff] = (!aux[ff] || String(aux[ff]).trim() === '' || aux[ff] === null || aux[ff] === 'NaN') ? '-' : aux[ff]
          }
        }
        data.push(aux)
        data2.push(aux2)
      }
      this.headers = header
      this.dataWeb = data2
      this.dataExcel = data
    },
    openAlimento (al) {
      let alimento = Object.assign({}, al)
      alimento.nutrientes = JSON.parse(alimento.nutrientes)
      alimento.tipo = alimento.id_tipo
      for (let nut in alimento.nutrientes) {
        alimento.nutrientes[nut] = parseFloat(alimento.nutrientes[nut]).toFixed(2).replace('.', this.strings[this.idioma].separador_float)
      }
      sessionStorage.setItem('alimentoCarregado', JSON.stringify(alimento))
      window.location.href = '/empresa/add-alimento'
    },
    atualizaVinculo (user) {
      let empresa = this.empresa
      let usuario = user
      let cargo = user.cargo
      let acesso = this.Cargos.filter(c => cargo === c.nome)[0].nivel
      this.axios.post('empresa/vincula', { id_empresa: empresa.id, id_pessoa: usuario.id, acesso: acesso }).then(response => {
        let msg = 'Atualizado!!!'
        let title = ''
        this.$store.commit('openOKModal', { title, msg })
        this.getData()
        getVinculados(this.$store.state, this.empresa.id, this.axios)
        this.currUser = null
        this.dietasCarregadas = null
      })
    },
    desvincula (user) {
      let empresa = this.empresa
      let usuario = user
      let cargo = user.cargo
      let acesso = this.Cargos.filter(c => cargo === c.nome)[0].nivel
      if (confirm('Você tem certeza disso? [Sim - OK]')) {
        this.axios.post('empresa/desvincula', { id_empresa: empresa.id, id_pessoa: usuario.id, acesso: acesso }).then(response => {
          let msg = 'Desvinculado!!!'
          let title = ''
          this.$store.commit('openOKModal', { title, msg })
          this.getData()
          getVinculados(this.$store.state, this.empresa.id, this.axios)
          this.currUser = null
          this.dietasCarregadas = null
        })
      }
    },
    selecionaEmpresa (emp) {
      this.empresa = emp
      sessionStorage.setItem('empresaAdm', JSON.stringify(emp))
      this.exportando_dados = true
      return this.getData().then(() => {
        return getVinculados(this.$store.state, this.empresa.id, this.axios, { dataInicial: this.dataInicial, dataFinal: this.dataFinal }).then(r => {
          this.exportando_dados = false
          return this.dataAdapter()
        })
      })
    },
    queryWork () {
      if (this.$route.query.link) {
        sessionStorage.setItem('link', this.$route.query.link)
        window.location.href = '/'
      } else if (sessionStorage.getItem('link')) {
        let linkURL = sessionStorage.getItem('link')
        sessionStorage.removeItem('link')
        this.linkURL = linkURL
      }
    },
    loadAlimentosDieta () {
      this.loadingAlimentos = true
      this.loadingStep1 = true

      this.axios.post('alimentos/lastUpdateAt', {}).then(response => {
        let lastUpdate = parseInt(response.data.data[1])

        if (lastUpdate === parseInt(localStorage.getItem('lastUpdate'))) {
          if (this.categorias_alimentos) {
            this.loadingStep1 = this.loadingAlimentos = false
            return
          }
          let tipos = JSON.parse(localStorage.getItem('tipos'))
          let alimentos = JSON.parse(localStorage.getItem('alimentos'))
          this.$store.commit('setAlimentos', {
            tipos: tipos,
            alimentos: alimentos
          })
          this.loadingAlimentos = false
          this.loadingStep1 = false
        } else {
          this.axios.post('tipos', {}).then(response => {
            let tipos = response.data.data
            localStorage.setItem('tipos', JSON.stringify(tipos))
            this.axios.post('relatorio/alimentosBrCorte', {}).then(response => {
              localStorage.setItem('alimentos', JSON.stringify(response.data.data))
              this.$store.commit('setAlimentos', {
                tipos: tipos,
                alimentos: response.data.data
              })
              this.loadingAlimentos = false
              this.loadingStep1 = false
              localStorage.setItem('lastUpdate', lastUpdate)
            }).catch(error => {
              console.log(error)
            })
          })
        }
      }).catch(reason => {
        console.log(reason)
      })
    },
    moment (...args) {
      return moment(...args)
    },
    getData () {
      if (this.empresa === null) return []
      this.exportando_dados = true
      return Promise.all([
        getDataEmpresa(this.$store.state, this.empresa.id, this.axios, {
          dataInicial: this.dataInicial,
          dataFinal: this.dataFinal,
          usuariosSelecionados: this.usuariosSelecionados,
          tiposAnimais: this.tiposAnimais,
          tiposUsuarios: this.tiposUsuarios
        }),
        this.dietasNaoVinculados ? getDietasNaoVinculados(this.$store.state, this.empresa.id, this.axios, {
          dataInicial: this.dataInicial,
          dataFinal: this.dataFinal,
          tiposAnimais: this.tiposAnimais
        }) : null
      ]).then(res => {
        console.log({ res })
        if (!res[1]) {
          this.exportando_dados = false
          return
        }
        for (let dieta of res[1]) {
          this.dietas.push(dieta)
        }
        this.exportando_dados = false
      })
    },
    updateData () {
      return updateData(this.$store.state, this.axios)
    },
    openDieta (dieta) {
      if (!isNaN(parseInt(dieta))) {
        for (let dieta_ of Object.values(this.dietasFilter)) {
          if (dieta_.id === dieta) {
            dieta = dieta_
            break
          }
        }
      }
      if (!isNaN(parseInt(dieta))) return
      if (dieta.tipo_alimento_predicao && (dieta.tipo_alimento_predicao === 'MS' || dieta.tipo_alimento_predicao === 'MN')) {
        this.openPredicao(dieta)
      } else {
        this.$store.commit('loadDieta', dieta.name)
        setTimeout(() => {
          window.open('/formulacao-dieta?dieta=' + btoa(JSON.stringify(dieta)), '_blank')
        }, 300)
      }
    },
    openPredicao (dieta) {
      this.$store.commit('loadPredicao', dieta.name)
      setTimeout(() => {
        window.open('/predicao-desempenho?predicao=' + btoa(JSON.stringify(dieta)), '_blank')
      }, 300)
    }
  }
}
</script>
